/** constructor
 * Provides traditional drag box zoom in/out and pan
 * Four possible modes: in, out, pan, off
*/

import DragZoom from '../node_modules/ol/interaction/DragZoom.js';
import {unByKey} from '../node_modules/ol/Observable.js';

export default function(map) {
  var eventListener, zoomBox;

  var zoom = function(mode) {
    if (mode === 'off') {
      unByKey(eventListener);  // disable single click
      map.removeInteraction(zoomBox);  // disable box DragZoom
      document.getElementById('map-div').style.cursor = 'auto';
      return;

    } else if (mode === 'in' || mode === 'out') {

      // add a singleclick listener
      eventListener = map.on('click', function(evt) {
        var view = map.getView();
        view.setZoom(view.getZoom() + (mode === 'out' ? -1 : 1) );
        view.setCenter(evt.coordinate);
      });

      // add a drag event listener
      zoomBox = new DragZoom({
        condition: function(e) { return true; },  // eslint-disable-line no-unused-vars
        out: mode === 'out' ? true : false
      });
      map.addInteraction(zoomBox);

      // set the cursor
      if (mode === 'in') {
        document.getElementById('map-div').style.cursor = "url('//gwmap.s3.amazonaws.com/mapserver/common/rwg/css/img/zoomInRWG.cur'),auto";  // eslint-disable-line quotes
      } else {
        document.getElementById('map-div').style.cursor = "url('//gwmap.s3.amazonaws.com/mapserver/common/rwg/css/img/zoomOutRWG.cur'),auto"; // eslint-disable-line quotes
      }


    } else if (mode === 'pan') {
      // seems like more needs to be done here but not sure what
      document.getElementById('map-div').style.cursor = "url('//gwmap.s3.amazonaws.com/mapserver/common/rwg/css/img/handRWG.cur'),auto"; // eslint-disable-line quotes
    }

  };

  /* *********

  // https://openlayers.org/en/latest/apidoc/ol.MapBrowserEvent.html
  // http://stackoverflow.com/questions/30020424/changing-cursor-on-drag-in-openlayers-3

  rwg.cursor = document.getElementById('map-div').style.cursor;

  // NEED TO PUSH THE CURRENT CURSOR on tool change, e.g. measure tools
  // maybe cursor handling belongs in ToolManager because need to what tool is active, e.g. if zoom tool is active don't change cursor to hand-dragging

  map.on('pointerdrag', function(e) {
    rwg.cursor =  document.getElementById('map-div').style.cursor;
    console.log(cursor);
    // console.log(e.pointerEvent.ctrlKey);
    if (e.pointerEvent.shiftKey) {
      document.getElementById('map-div').style.cursor = "url('//gwmap.s3.amazonaws.com/mapserver/common/rwg/css/img/zoomInRWG.cur'),auto";
    } else if (e.pointerEvent.ctrlKey) {
      document.getElementById('map-div').style.cursor = 'help';
    } else {
      // -webkit-grabbing
      document.getElementById('map-div').style.cursor = "url('//gwmap.s3.amazonaws.com/mapserver/common/rwg/css/img/handRWG.cur'),auto";
    }
  });



  // map.on('moveend', function(evt) {  // already have one 'moveend' function above, combine?
  // map.on('postrender', function(evt) {
  map.on('pointerup', function(evt) {
    // map.getViewport().style.cursor = 'help'; // cursor; // "-webkit-grab";
    document.getElementById('map-div').style.cursor = rwg.cursor;
  });

   ********* */

  return zoom;
}

/*
zoomBox = new ol.interaction.DragZoom({
  // This DragZoom interaction seems to get called on all 'pointerdown' events.
  // The unused 'contion' function below checks the active tool and
  // tells the DragZoom interaction whether or not to process the event.
  condition: function(e) {
    return (toolManager.getActiveTool() === 'zoominbox') ? true : ol.events.condition.shiftKeyOnly(e);
  },
  out: mode === 'out' ? true : false
});
*/
